/**
 * src/db/contact.db.js
 */

export const contactData = {
    hero: {
        label:    'Contáctenos',
        headline: '¿Cómo podemos ayudarte?',
        sub:      'Estamos aquí para responder tus preguntas, ayudarte a publicar tu negocio o resolver cualquier inquietud.'
    },
    info: [
        {
            id:    'phone',
            icon:  '📞',
            title: 'Teléfono / WhatsApp',
            lines: ['+57 312 428 8323'],
            link:  'https://wa.me/573124288323',
            linkLabel: 'Escribir por WhatsApp'
        },
        {
            id:    'email',
            icon:  '✉️',
            title: 'Correo electrónico',
            lines: ['contacto@ubiyaaafusa.com'],
            link:  'mailto:contacto@ubiyaaafusa.com',
            linkLabel: 'Enviar correo'
        },
        {
            id:    'address',
            icon:  '📍',
            title: 'Ubicación',
            lines: ['Centro Comercial Manila', 'Fusagasugá, Cundinamarca'],
            link:  'https://www.google.com/maps/search/Centro+Comercial+Manila+Fusagasuga',
            linkLabel: 'Ver en mapa'
        },
        {
            id:    'hours',
            icon:  '🕘',
            title: 'Horario de atención',
            lines: ['Lun – Vie: 8:00 am – 6:00 pm', 'Sáb: 9:00 am – 2:00 pm'],
            link:  null,
            linkLabel: null
        }
    ],
    form: {
        subjects: [
            'Publicar mi negocio',
            'Soporte técnico',
            'Información general',
            'Reportar un problema',
            'Otro'
        ]
    },
    mapEmbed: 'https://maps.google.com/maps?q=Fusagasuga%2C+Cundinamarca%2C+Colombia&output=embed'
}
